<ng-container *transloco="let t; prefix: 'toolbar'">
    <div class="w-full flex justify-between items-center h-8">
        <div class="flex items-center gap-4">
            <div class="flex flex-col items-center justify-center">
                <button
                    mat-icon-button
                    class="toggle-sidebar-folded hidden lg:block"
                    (click)="toggleSidebarFolded()"
                    appDisabledWhenExpired
                >
                    <mat-icon>menu</mat-icon>
                </button>

                <button
                    mat-icon-button
                    class="toggle-sidebar-opened block lg:hidden"
                    (click)="toggleSidebarOpened()"
                    appDisabledWhenExpired
                >
                    <mat-icon>menu</mat-icon>
                </button>
            </div>
            <img class="h-8 w-8" [src]="logoUrl" />
        </div>

        <div class="flex items-center gap-4">
            <transcription-usage-alert></transcription-usage-alert>
            @if(showAlert || showCanceledTrialAlert) {
            <div class="cursor-pointer" (click)="navigateToSubscriptionDetails()">
                <fuse-alert
                    class="font-bold"
                    [appearance]="'outline'"
                    [type]="'warn'"
                    [dismissible]="false"
                    [showIcon]="true"
                >
                    <mat-icon fuseAlertIcon [svgIcon]="'exclamation-circle'"></mat-icon>
                    <span fuseAlertMessage>
                        {{ showCanceledTrialAlert ? t("subscription_canceled_trial_alert") : t("subscription_expired_alert") }}
                    </span>
                </fuse-alert>
            </div>
            }
            <!-- 
            TODO: Add when knowledge base is ready
            <button
                mat-icon-button
                [matMenuTriggerFor]="helpMenu"
                aria-label="Ajuda"
                matTooltip="Ajuda"
                appDisabledWhenExpired
            >
                <mat-icon [svgIcon]="'question-circle'"></mat-icon>
            </button> -->
            <mat-menu #helpMenu="matMenu" class="v2-menu">
                <button mat-menu-item (click)="openKb()">
                    <mat-icon [svgIcon]="'question-circle'"></mat-icon>
                    <span>{{ t("help_center") }}</span>
                </button>
                @if (supportChatEnabled) {
                <button mat-menu-item (click)="openChat()">
                    <mat-icon [svgIcon]="'comment-alt-message'"></mat-icon>
                    <span>{{ t("chat_with_vsaude") }}</span>
                </button>
                }
            </mat-menu>

            @if (canReturnToImpersonate) {
                <button
                    mat-icon-button
                    (click)="returnToTenants()"
                    [matTooltip]="t('return_to_tenants')"
                    [attr.aria-label]="t('return_to_tenants')"
                >
                    <mat-icon [svgIcon]="'sign-in-alt'"></mat-icon>
                </button>
            }

            <button mat-icon-button [matMenuTriggerFor]="profileMenu">
                <mat-icon [svgIcon]="'user'"></mat-icon>
            </button>
            <mat-menu #profileMenu="matMenu" class="v2-menu">
                <button mat-menu-item routerLink="/my-profile" appDisabledWhenExpired>
                    <mat-icon [svgIcon]="'user'"></mat-icon>
                    <span>{{ t("my_profile") }}</span>
                </button>
                <button mat-menu-item (click)="logout()">
                    <mat-icon [svgIcon]="'signout'"></mat-icon>
                    <span>{{ t("logout") }}</span>
                </button>
            </mat-menu>
        </div>
    </div>
</ng-container>
